import { csx, Flex } from '@vtex/admin-ui'
import { DefaultProps } from 'typings'
import { BuyAndWinRecap } from './BuyAndWin/Recap'
import { BuyTogetherRecap } from './BuyTogether'
import { MoreForLessRecap } from './MoreForLess/Recap'
import { ProgressiveDiscountRecap } from './ProgressiveDiscount/Recap'
import { RegularRecap } from './Regular/Recap'
import { AffectedProductsAlert } from './AffectedProductsAlert'

export function AlertsContainer(props: DefaultProps) {
  return (
    <Flex
      direction="column"
      className={csx({
        marginBottom: '$space-8',
        ':empty': { display: 'none' },
        '> div:has(+ div)': {
          boxShadow: '0px 2px 8px 0px #00000026',
        },
      })}
    >
      {props.children}
    </Flex>
  )
}

AlertsContainer.BuyTogetherRecap = BuyTogetherRecap
AlertsContainer.BuyAndWinRecap = BuyAndWinRecap
AlertsContainer.MoreForLessRecap = MoreForLessRecap
AlertsContainer.ProgressiveDiscountRecap = ProgressiveDiscountRecap
AlertsContainer.RegularRecap = RegularRecap
AlertsContainer.AffectedProducts = AffectedProductsAlert

export const Alerts = AlertsContainer
